import React, { useEffect, useRef, useState } from 'react';
import mapimage from '../../Assets/maps/mapimage.jpg';
import polyline from '@mapbox/polyline';
import { MdOutlineZoomOutMap } from "react-icons/md";

const DummyMapFromOLA = ({
  dropLongitude, dropLatitude, latitude, longitude,
  setLatitude = () => { },
  setLongitude = () => { },
  setDropLatitude = () => { },
  setDropLongitude = () => { },
  setDropLocation = () => { },
  setPickupLocation = () => { },
  inSideSelectOnMap
}) => {
  console.log("Props received:", { latitude, longitude, dropLatitude, dropLongitude });
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null); // Store map instance for fitBounds
  const [pickLat, setPickLat] = useState(null);
  const [pickLng, setPickLng] = useState(null);
  const [dropLat, setDropLat] = useState(null);
  const [dropLng, setDropLng] = useState(null);

 useEffect(() => {
  // Prefer props if valid
  const validLat = parseFloat(latitude);
  const validLng = parseFloat(longitude);
  const validDropLat = parseFloat(dropLatitude);
  const validDropLng = parseFloat(dropLongitude);

  if (!isNaN(validLat)) setPickLat(validLat);
  if (!isNaN(validLng)) setPickLng(validLng);
  if (!isNaN(validDropLat)) setDropLat(validDropLat);
  if (!isNaN(validDropLng)) setDropLng(validDropLng);

  // Fallback to localStorage if props are not valid
  if (isNaN(validLat)) {
    const storedLat = parseFloat(localStorage.getItem('pickLatitude'));
    if (!isNaN(storedLat)) setPickLat(storedLat);
  }

  if (isNaN(validLng)) {
    const storedLng = parseFloat(localStorage.getItem('pickLongitude'));
    if (!isNaN(storedLng)) setPickLng(storedLng);
  }

  if (isNaN(validDropLat)) {
    const storedDropLat = parseFloat(localStorage.getItem('dropLatitude'));
    if (!isNaN(storedDropLat)) setDropLat(storedDropLat);
  }

  if (isNaN(validDropLng)) {
    const storedDropLng = parseFloat(localStorage.getItem('dropLongitude'));
    if (!isNaN(storedDropLng)) setDropLng(storedDropLng);
  }
}, [latitude, longitude, dropLatitude, dropLongitude]);

  // useEffect(()=>{
  //   setPickLat(parseFloat(localStorage.getItem('pickLatitude')) || null);
  //   setPickLng(parseFloat(localStorage.getItem('pickLongitude')) || null);
  //   setDropLat(parseFloat(localStorage.getItem('dropLatitude')) || null);
  //   setDropLng (parseFloat(localStorage.getItem('dropLongitude')) || null);
  // },[])

  const [defaultLocation, setDefaultLocation] = useState([77.0679, 28.4354]); // [lng, lat]
  console.log("pickLng, pickLat,dropLng, dropLat", pickLng, pickLat, dropLng, dropLat)


  const prevPickup = useRef({ lat: null, lng: null });
  const prevDrop = useRef({ lat: null, lng: null });

  // Handler to fit both pickup and drop locations in view
  const handleFitBounds = () => {
    if (!mapInstanceRef.current || !pickLat || !pickLng || !dropLat || !dropLng) {
      console.warn('Map or coordinates not ready for fitBounds');
      return;
    }

    const myMap = mapInstanceRef.current;
    const swLat = Math.min(pickLat, dropLat);
    const swLng = Math.min(pickLng, dropLng);
    const neLat = Math.max(pickLat, dropLat);
    const neLng = Math.max(pickLng, dropLng);

    // myMap.fitBounds([[swLng, swLat], [neLng, neLat]], { padding: 80, duration: 1000 });
    myMap.fitBounds(
    [
      [swLng, swLat],
      [neLng, neLat]
    ],
    {
      padding: {
        top: 80,
        bottom: 280,
        left: 80,
        right: 80
      },
      duration: 1000
    }
  );
  };

  useEffect(() => {
    if (mapInstanceRef.current && pickLat && pickLng && dropLat && dropLng) {
      // Add a small delay to ensure the route polyline is rendered before zooming
      const timer = setTimeout(() => {
        handleFitBounds();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [pickLat, pickLng, dropLat, dropLng]);

  useEffect(() => {
    console.log('Map ref:', mapRef.current.id);
    console.log('Default location:', defaultLocation);
    console.log('pickLng, pickLat, dropLng, dropLng', pickLng, pickLat, dropLng, dropLng)
    const loadMap = async () => {
      if (!mapRef.current) {
        console.log('Map ref is still null!');
        return;
      }// ✅ Correct check
      const { OlaMaps } = await import('olamaps-web-sdk');
      const apiKey = process.env.REACT_APP_OLA_API_KEY;
      const olaMaps = new OlaMaps({
        apiKey
      });


      console.log('setting map on default location', defaultLocation)
      const hasPickup = pickLng != null && pickLat != null && !isNaN(pickLng) && !isNaN(pickLat);
      const mapCenter = hasPickup ? [pickLng, pickLat] : defaultLocation;

      console.log('Trying to initialize map in container:', mapRef.current);
      const myMap = olaMaps.init({
        style: 'https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json',
        container: mapRef.current,
        center: mapCenter, // default center
        zoom: 15,
      });

      // Store map instance for fitBounds functionality
      mapInstanceRef.current = myMap;

      const navigationControls = olaMaps.addNavigationControls({
        showCompass: true,
        showZoom: false,
        visualizePitch: false,
      });

      myMap.addControl(navigationControls);

            // const bounds = new myMap.mapboxgl.LngLatBounds();

      const setters = {
        pickup: setPickupLocation,
        drop: setDropLocation,
      };
      // Function to fetch address from coordinates
      const getAddressFromCoords = async (lat, lng, label) => {
        try {
          // const res = await fetch(`https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat,lng}&api_key=${apiKey}`);
          const res = await fetch(`https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat},${lng}&api_key=${apiKey}`);

          const data = await res.json();
          console.log('data?.fetched', data)
          const address = data?.results?.[0]?.formatted_address || 'Unknown address';
          console.log(`${label} Address:`, address);

          // Optionally store address as well
          setters[label](address);
          localStorage.setItem(`${label}Loc`, address);
          if (!localStorage.getItem('currentLoc')) {
      localStorage.setItem('currentLoc', address);
      console.log('📍 Stored currentLoc for the first time:', address);
    }
        } catch (err) {
          console.error(`Failed to fetch ${label} address`, err);
        }
      };

      // Try to get user's current location
  const storedLocation = localStorage.getItem('gps_location');
  const stroedursie = localStorage.getItem('userId');

  console.log('storedLocation', storedLocation)
  console.log('stroedursie', stroedursie)

    try {
      console.log('stored', storedLocation)
      const parsedLocation = JSON.parse(storedLocation);

      console.log('Real GPS location:', parsedLocation);
         const { lat, lng } = parsedLocation;
          const userLng = lng;
          const userLat = lat;

            if (!localStorage.getItem('pickupLoc')) {
              getAddressFromCoords(userLat, userLng, 'pickup');
            }

          if (!pickLat || !pickLng) {
            // Only show current location marker if pickup/drop not set
            olaMaps
              .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green' })
              .setLngLat([userLng, userLat])
              .addTo(myMap);
            myMap.setCenter([userLng, userLat]);
            setPickLat(userLat);
            setPickLng(userLng);
            setLatitude(userLat);
            setLongitude(userLng);
            localStorage.setItem('pickLatitude', userLat);
            localStorage.setItem('pickLongitude', userLng);
            console.log("localStorage.getItem('pickupLoc')")

            console.log("localStorage.getItem('pickupLoc')", localStorage.getItem('pickupLoc'))
         
          }
    } catch (err) {
      console.error('❌ Failed to parse GPS location:', err);
    }





      // Add pickup marker
      if (pickLat && pickLng) {
        const pickupMarker = olaMaps
          .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'black', draggable: true })
          .setLngLat([pickLng, pickLat])
          .addTo(myMap);

        pickupMarker.on('dragend', () => {
          const { lng, lat } = pickupMarker.getLngLat();
          console.log('Updated pickup coords:', lat, lng);

          setPickLat(lat);
          setPickLng(lng);
          setLatitude(lat);
          setLongitude(lng);



          localStorage.setItem('pickLatitude', lat);
          localStorage.setItem('pickLongitude', lng);

          getAddressFromCoords(lat, lng, 'pickup');
        });

        // Initial address fetch
        // getAddressFromCoords(pickLat, pickLng, 'pickup');
      }


      // Add drop marker
      if (dropLat && dropLng) {
        const dropMarker = olaMaps
          .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green', draggable: true })
          .setLngLat([dropLng, dropLat])
          .addTo(myMap);

        dropMarker.on('dragend', () => {
          const { lng, lat } = dropMarker.getLngLat();
          console.log('Updated drop coords:', lat, lng);


          setDropLat(lat);
          setDropLng(lng);
          setDropLatitude(lat);
          setDropLongitude(lng);

          localStorage.setItem('dropLatitude', lat);
          localStorage.setItem('dropLongitude', lng);

          getAddressFromCoords(lat, lng, 'drop');
        });

        // Initial address fetch
        // getAddressFromCoords(dropLat, dropLng, 'drop');
      }


      // If either marker exists, fit the view
      if (pickLat && pickLng && dropLat && dropLng) {
        // let center = [dropLng, dropLat]
        // if (pickLat && pickLng && (!prevPickup.current.lat || prevPickup.current.lat !== pickLat || prevPickup.current.lng !== pickLng)) {
        //   center = [pickLng, pickLat];
        //   console.log('Centering on updated pickup');
        //   prevPickup.current = { lat: pickLat, lng: pickLng };
        // }

        // if (dropLat && dropLng && (!prevDrop.current.lat || prevDrop.current.lat !== dropLat || prevDrop.current.lng !== dropLng)) {
        //   center = [dropLng, dropLat];
        //   console.log('Centering on updated drop');
        //   prevDrop.current = { lat: dropLat, lng: dropLng };
        // }

        // myMap.setCenter(center);
        // myMap.setPitch(0);
        // myMap.setBearing(0);
        // [15].forEach(z => {
        //   setTimeout(() => myMap.setZoom(z), 100 * z);
        // });

        // const swLat = Math.min(pickLat, dropLat);
        // const swLng = Math.min(pickLng, dropLng);
        // const neLat = Math.max(pickLat, dropLat);
        // const neLng = Math.max(pickLng, dropLng);
        // myMap.fitBounds([[swLng, swLat], [neLng, neLat]], { padding: 80 });
        console.log('Both markers ready - fitBounds will be auto-triggered by separate useEffect');


      }
      else if (pickLat && pickLng) {
        myMap.setCenter([pickLng, pickLat]);

        myMap.setPitch(0);
        myMap.setBearing(0);
        [15].forEach(z => {
          setTimeout(() => myMap.setZoom(z), 100 * z);
        });

        console.log('actual zoom level:', myMap.getZoom());


      } else if (dropLat && dropLng) {
        myMap.setCenter([dropLng, dropLat]);
        myMap.setPitch(0);
        myMap.setBearing(0);
        [15].forEach(z => {
          setTimeout(() => myMap.setZoom(z), 100 * z);
        });

      } else {
        // Use current location as fallback
        navigator.geolocation.getCurrentPosition((position) => {
          const userLng = position.coords.longitude;
          const userLat = position.coords.latitude;

          // ✅ Update map view to user location
          myMap.setCenter([userLng, userLat]);
          myMap.setPitch(0);
          myMap.setBearing(0);
          myMap.setZoom(18);

          // ✅ Store this in state so future reloads start from here
          setDefaultLocation([userLng, userLat]);

          // Optional marker
          olaMaps
            .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'black' })
            .setLngLat([userLng, userLat])
            .addTo(myMap);
        });
      }



      if (pickLat && pickLng && !dropLat && !dropLng) {
        myMap.setCenter([pickLng, pickLat]);
        myMap.setZoom(15);
      }

      // If both pickup and drop exist, draw the route
      if (pickLat && pickLng && dropLat && dropLng) {
        const swLat = Math.min(pickLat, dropLat);
        const swLng = Math.min(pickLng, dropLng);
        const neLat = Math.max(pickLat, dropLat);
        const neLng = Math.max(pickLng, dropLng);

        // myMap.fitBounds(
        //   [[swLng, swLat], [neLng, neLat]],
        //   { padding: 80, duration: 1000 }
        // );
        const getRouteData = async () => {
          try {
            const origin = `${pickLat},${pickLng}`;
            const destination = `${dropLat},${dropLng}`;
            // const url = `https://api.olamaps.io/routing/v1/directions?origin=${origin}&destination=${destination}&api_key=${apiKey}`;
            const url = `https://api.olamaps.io/routing/v1/routeOptimizer?locations=${pickLat},${pickLng}|${dropLat},${dropLng}&api_key=${apiKey}`

            const response = await fetch(url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({}),
            });

            const data = await response.json();
            return data;
          } catch (err) {
            console.error("Error fetching route data:", err);
          }
        };

        myMap.on('load', async () => {
          const routeData = await getRouteData();
          if (!routeData?.routes?.[0]) return;

          const encodedPolyline = routeData.routes[0].overview_polyline;
          const decoded = polyline.decode(encodedPolyline);
          const coordinates = decoded.map(([lat, lng]) => [lng, lat]);

          if (myMap.getSource('route')) myMap.removeSource('route');
          if (myMap.getLayer('route')) myMap.removeLayer('route');

          myMap.addSource('route', {
            type: 'geojson',
            data: {
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'LineString',
                coordinates,
              },
            },
          });

          myMap.addLayer({
            id: 'route',
            type: 'line',
            source: 'route',
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#33c1ff',
              'line-width': 4,
            },
          });
        });
      }
    };
    console.log('Ref:', mapRef.current, 'Type:', typeof mapRef.current);

    const timeout = setTimeout(() => {
      loadMap();
    }, 100);
    return () => clearTimeout(timeout);
  }, [pickLat, pickLng, dropLat, dropLng]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <div
        id="map"
        ref={mapRef}
        style={{
          backgroundImage: `url(${mapimage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100vw',
          height: inSideSelectOnMap ? '100vh' : '30vh',
        }}
      />
      {/* Fit Bounds Button */}
      {pickLat && pickLng && dropLat && dropLng && (
        <button
          onClick={handleFitBounds}
          style={{
            position: 'absolute',
            bottom: '274px',
            right: '15px',
            padding: '6px',
            backgroundColor: '#FFFFFF',
            color: '#374151',
            border: '3px solid #D1D5DB',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            zIndex: 100,
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
            transition: 'background-color 0.3s ease',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#F3F4F6'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#FFFFFF'}
        >
          <MdOutlineZoomOutMap size={16} />
        </button>
      )}
    </div>
  );
};

export default DummyMapFromOLA;




// import React, { useEffect, useRef, useState } from 'react';
// import mapimage from '../../Assets/maps/mapimage.jpg';
// import polyline from '@mapbox/polyline';

// const DummyMapFromOLA = ({
//   dropLongitude, dropLatitude, latitude, longitude,
//   setLatitude = () => { },
//   setLongitude = () => { },
//   setDropLatitude = () => { },
//   setDropLongitude = () => { },
//   setDropLocation = () => { },
//   setPickupLocation = () => { },
//   inSideSelectOnMap
// }) => {
//   console.log("Props received:", { latitude, longitude, dropLatitude, dropLongitude });
//   const mapRef = useRef(null);
//   const [pickLat, setPickLat] = useState(null);
//   const [pickLng, setPickLng] = useState(null);
//   const [dropLat, setDropLat] = useState(null);
//   const [dropLng, setDropLng] = useState(null);

//   useEffect(() => {
//     if (!isNaN(parseFloat(latitude))) {
//       setPickLat(parseFloat(latitude));
//     }
//     if (!isNaN(parseFloat(longitude))) {
//       setPickLng(parseFloat(longitude));
//     }
//     if (!isNaN(parseFloat(dropLatitude))) {
//       setDropLat(parseFloat(dropLatitude));
//     }
//     if (!isNaN(parseFloat(dropLongitude))) {
//       setDropLng(parseFloat(dropLongitude));
//     }

//     setPickLat(localStorage.getItem('pickLatitude'))
//     setPickLng(localStorage.getItem('pickLongitude'))
//     setDropLat(localStorage.getItem('dropLatitude'))
//     setDropLng(localStorage.getItem('dropLongitude'))

//   }, [latitude, longitude, dropLatitude, dropLongitude]);

//   // useEffect(()=>{
//   //   setPickLat(parseFloat(localStorage.getItem('pickLatitude')) || null);
//   //   setPickLng(parseFloat(localStorage.getItem('pickLongitude')) || null);
//   //   setDropLat(parseFloat(localStorage.getItem('dropLatitude')) || null);
//   //   setDropLng (parseFloat(localStorage.getItem('dropLongitude')) || null);
//   // },[])

//   const [defaultLocation, setDefaultLocation] = useState([77.0679, 28.4354]); // [lng, lat]
//   console.log("pickLng, pickLat,dropLng, dropLat", pickLng, pickLat, dropLng, dropLat)


//   const prevPickup = useRef({ lat: null, lng: null });
//   const prevDrop = useRef({ lat: null, lng: null });

//   useEffect(() => {
//     console.log('Map ref:', mapRef.current.id);
//     console.log('Default location:', defaultLocation);
//     console.log('pickLng, pickLat, dropLng, dropLng', pickLng, pickLat, dropLng, dropLng)
//     const loadMap = async () => {
//       if (!mapRef.current) {
//         console.log('Map ref is still null!');
//         return;
//       }// ✅ Correct check
//       const { OlaMaps } = await import('olamaps-web-sdk');
//       const apiKey = process.env.REACT_APP_OLA_API_KEY;
//       const olaMaps = new OlaMaps({
//         apiKey
//       });


//       console.log('setting map on default location', defaultLocation)
//       const hasPickup = pickLng != null && pickLat != null && !isNaN(pickLng) && !isNaN(pickLat);
//       const mapCenter = hasPickup ? [pickLng, pickLat] : defaultLocation;

//       console.log('Trying to initialize map in container:', mapRef.current);
//       const myMap = olaMaps.init({
//         style: 'https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json',
//         container: mapRef.current,
//         center: mapCenter, // default center
//         zoom: 15,
//       });

//       const navigationControls = olaMaps.addNavigationControls({
//         showCompass: true,
//         showZoom: false,
//         visualizePitch: false,
//       });

//       myMap.addControl(navigationControls);

//             // const bounds = new myMap.mapboxgl.LngLatBounds();

//       const setters = {
//         pickup: setPickupLocation,
//         drop: setDropLocation,
//       };
//       // Function to fetch address from coordinates
//       const getAddressFromCoords = async (lat, lng, label) => {
//         try {
//           // const res = await fetch(`https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat,lng}&api_key=${apiKey}`);
//           const res = await fetch(`https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat},${lng}&api_key=${apiKey}`);

//           const data = await res.json();
//           console.log('data?.fetched', data)
//           const address = data?.results?.[0]?.formatted_address || 'Unknown address';
//           console.log(`${label} Address:`, address);

//           // Optionally store address as well
//           setters[label](address);
//           localStorage.setItem(`${label}Loc`, address);
//           if (!localStorage.getItem('currentLoc')) {
//       localStorage.setItem('currentLoc', address);
//       console.log('📍 Stored currentLoc for the first time:', address);
//     }
//         } catch (err) {
//           console.error(`Failed to fetch ${label} address`, err);
//         }
//       };

//       // Try to get user's current location
//   const storedLocation = localStorage.getItem('gps_location');
//   const stroedursie = localStorage.getItem('userId');

//   console.log('storedLocation', storedLocation)
//   console.log('stroedursie', stroedursie)

//     try {
//       console.log('stored', storedLocation)
//       const parsedLocation = JSON.parse(storedLocation);

//       console.log('Real GPS location:', parsedLocation);
//          const { lat, lng } = parsedLocation;
//           const userLng = lng;
//           const userLat = lat;

//             if (!localStorage.getItem('pickupLoc')) {
//               getAddressFromCoords(userLat, userLng, 'pickup');
//             }

//           if (!pickLat || !pickLng) {
//             // Only show current location marker if pickup/drop not set
//             olaMaps
//               .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green' })
//               .setLngLat([userLng, userLat])
//               .addTo(myMap);
//             myMap.setCenter([userLng, userLat]);
//             setPickLat(userLat);
//             setPickLng(userLng);
//             setLatitude(userLat);
//             setLongitude(userLng);
//             localStorage.setItem('pickLatitude', userLat);
//             localStorage.setItem('pickLongitude', userLng);
//             console.log("localStorage.getItem('pickupLoc')")

//             console.log("localStorage.getItem('pickupLoc')", localStorage.getItem('pickupLoc'))
         
//           }
//     } catch (err) {
//       console.error('❌ Failed to parse GPS location:', err);
//     }





//       // Add pickup marker
//       if (pickLat && pickLng) {
//         const pickupMarker = olaMaps
//           .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'black', draggable: true })
//           .setLngLat([pickLng, pickLat])
//           .addTo(myMap);

//         pickupMarker.on('dragend', () => {
//           const { lng, lat } = pickupMarker.getLngLat();
//           console.log('Updated pickup coords:', lat, lng);

//           setPickLat(lat);
//           setPickLng(lng);
//           setLatitude(lat);
//           setLongitude(lng);



//           localStorage.setItem('pickLatitude', lat);
//           localStorage.setItem('pickLongitude', lng);

//           getAddressFromCoords(lat, lng, 'pickup');
//         });

//         // Initial address fetch
//         // getAddressFromCoords(pickLat, pickLng, 'pickup');
//       }


//       // Add drop marker
//       if (dropLat && dropLng) {
//         const dropMarker = olaMaps
//           .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green', draggable: true })
//           .setLngLat([dropLng, dropLat])
//           .addTo(myMap);

//         dropMarker.on('dragend', () => {
//           const { lng, lat } = dropMarker.getLngLat();
//           console.log('Updated drop coords:', lat, lng);


//           setDropLat(lat);
//           setDropLng(lng);
//           setDropLatitude(lat);
//           setDropLongitude(lng);

//           localStorage.setItem('dropLatitude', lat);
//           localStorage.setItem('dropLongitude', lng);

//           getAddressFromCoords(lat, lng, 'drop');
//         });

//         // Initial address fetch
//         // getAddressFromCoords(dropLat, dropLng, 'drop');
//       }


//       // If either marker exists, fit the view
//       if (pickLat && pickLng && dropLat && dropLng) {
//         let center = [dropLng, dropLat]
//         if (pickLat && pickLng && (!prevPickup.current.lat || prevPickup.current.lat !== pickLat || prevPickup.current.lng !== pickLng)) {
//           center = [pickLng, pickLat];
//           console.log('Centering on updated pickup');
//           prevPickup.current = { lat: pickLat, lng: pickLng };
//         }

//         if (dropLat && dropLng && (!prevDrop.current.lat || prevDrop.current.lat !== dropLat || prevDrop.current.lng !== dropLng)) {
//           center = [dropLng, dropLat];
//           console.log('Centering on updated drop');
//           prevDrop.current = { lat: dropLat, lng: dropLng };
//         }

//         myMap.setCenter(center);
//         myMap.setPitch(0);
//         myMap.setBearing(0);
//         [13, 14, 15, 16, 17, 18].forEach(z => {
//           setTimeout(() => myMap.setZoom(z), 100 * z);
//         });

//         // const swLat = Math.min(pickLat, dropLat);
//         // const swLng = Math.min(pickLng, dropLng);
//         // const neLat = Math.max(pickLat, dropLat);
//         // const neLng = Math.max(pickLng, dropLng);
//         // myMap.fitBounds([[swLng, swLat], [neLng, neLat]], { padding: 80 });

//       }
//       else if (pickLat && pickLng) {
//         myMap.setCenter([pickLng, pickLat]);

//         myMap.setPitch(0);
//         myMap.setBearing(0);
//         [13, 14, 15, 16, 17, 18].forEach(z => {
//           setTimeout(() => myMap.setZoom(z), 100 * z);
//         });

//         console.log('actual zoom level:', myMap.getZoom());


//       } else if (dropLat && dropLng) {
//         myMap.setCenter([dropLng, dropLat]);
//         myMap.setPitch(0);
//         myMap.setBearing(0);
//         [13, 14, 15, 16, 17, 18].forEach(z => {
//           setTimeout(() => myMap.setZoom(z), 100 * z);
//         });

//       } else {
//         // Use current location as fallback
//         navigator.geolocation.getCurrentPosition((position) => {
//           const userLng = position.coords.longitude;
//           const userLat = position.coords.latitude;

//           // ✅ Update map view to user location
//           myMap.setCenter([userLng, userLat]);
//           myMap.setPitch(0);
//           myMap.setBearing(0);
//           myMap.setZoom(18);

//           // ✅ Store this in state so future reloads start from here
//           setDefaultLocation([userLng, userLat]);

//           // Optional marker
//           olaMaps
//             .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'black' })
//             .setLngLat([userLng, userLat])
//             .addTo(myMap);
//         });
//       }



//       if (pickLat && pickLng && !dropLat && !dropLng) {
//         myMap.setCenter([pickLng, pickLat]);
//         myMap.setZoom(15);
//       }

//       // If both pickup and drop exist, draw the route
//       if (pickLat && pickLng && dropLat && dropLng) {
//         const swLat = Math.min(pickLat, dropLat);
//         const swLng = Math.min(pickLng, dropLng);
//         const neLat = Math.max(pickLat, dropLat);
//         const neLng = Math.max(pickLng, dropLng);

//         // myMap.fitBounds(
//         //   [[swLng, swLat], [neLng, neLat]],
//         //   { padding: 80, duration: 1000 }
//         // );
//         const getRouteData = async () => {
//           try {
//             const origin = `${pickLat},${pickLng}`;
//             const destination = `${dropLat},${dropLng}`;
//             // const url = `https://api.olamaps.io/routing/v1/directions?origin=${origin}&destination=${destination}&api_key=${apiKey}`;
//             const url = `https://api.olamaps.io/routing/v1/routeOptimizer?locations=${pickLat},${pickLng}|${dropLat},${dropLng}&api_key=${apiKey}`

//             const response = await fetch(url, {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({}),
//             });

//             const data = await response.json();
//             return data;
//           } catch (err) {
//             console.error("Error fetching route data:", err);
//           }
//         };

//         myMap.on('load', async () => {
//           const routeData = await getRouteData();
//           if (!routeData?.routes?.[0]) return;

//           const encodedPolyline = routeData.routes[0].overview_polyline;
//           const decoded = polyline.decode(encodedPolyline);
//           const coordinates = decoded.map(([lat, lng]) => [lng, lat]);

//           if (myMap.getSource('route')) myMap.removeSource('route');
//           if (myMap.getLayer('route')) myMap.removeLayer('route');

//           myMap.addSource('route', {
//             type: 'geojson',
//             data: {
//               type: 'Feature',
//               properties: {},
//               geometry: {
//                 type: 'LineString',
//                 coordinates,
//               },
//             },
//           });

//           myMap.addLayer({
//             id: 'route',
//             type: 'line',
//             source: 'route',
//             layout: {
//               'line-join': 'round',
//               'line-cap': 'round',
//             },
//             paint: {
//               'line-color': '#33c1ff',
//               'line-width': 4,
//             },
//           });
//         });
//       }
//     };
//     console.log('Ref:', mapRef.current, 'Type:', typeof mapRef.current);

//     const timeout = setTimeout(() => {
//       loadMap();
//     }, 100);
//     return () => clearTimeout(timeout);
//   }, [pickLat, pickLng, dropLat, dropLng]);

//   return (
//     <div
//       id="map"
//       ref={mapRef}
//       style={{
//         backgroundImage: `url(${mapimage})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         width: '100vw',
//         height: inSideSelectOnMap ? '100vh' : '30vh',
//       }}
//     />
//   );
// };

// export default DummyMapFromOLA;




// import React, { useEffect, useRef, useState } from 'react';
// import mapimage from '../../Assets/maps/mapimage.jpg';
// import polyline from '@mapbox/polyline';

// const DummyMapFromOLA = ({
//   /* ⇢ existing props … */
//   dropLongitude,
//   dropLatitude,
//   latitude,
//   longitude,
//   setLatitude = () => { },
//   setLongitude = () => { },
//   setDropLatitude = () => { },
//   setDropLongitude = () => { },
//   setDropLocation = () => { },
//   setPickupLocation = () => { },
//   /* ————— NEW PROPS ————— */
//   setIsPickupSelectedFromSuggestion = () => { },   // ★ FIX: new
//   setIsDropSelectedFromSuggestion = () => { },     // ★ FIX: new
//   /* ---------------------------------------------------------- */
//   inSideSelectOnMap,
// }) => {
//   const mapRef = useRef(null);
//   const [pickLat, setPickLat] = useState(null);
//   const [pickLng, setPickLng] = useState(null);
//   const [dropLat, setDropLat] = useState(null);
//   const [dropLng, setDropLng] = useState(null);

//   /* ----------------------------------------------------------
//      READ coordinates coming from parent (unchanged)
//   ---------------------------------------------------------- */
//   useEffect(() => {
//     if (!isNaN(parseFloat(latitude))) setPickLat(parseFloat(latitude));
//     if (!isNaN(parseFloat(longitude))) setPickLng(parseFloat(longitude));
//     if (!isNaN(parseFloat(dropLatitude))) setDropLat(parseFloat(dropLatitude));
//     if (!isNaN(parseFloat(dropLongitude))) setDropLng(parseFloat(dropLongitude));

//     /* keep localStorage fall‑back (unchanged) */
//     setPickLat(localStorage.getItem('pickLatitude'));
//     setPickLng(localStorage.getItem('pickLongitude'));
//     setDropLat(localStorage.getItem('dropLatitude'));
//     setDropLng(localStorage.getItem('dropLongitude'));
//   }, [latitude, longitude, dropLatitude, dropLongitude]);

//   /* ----------------------------------------------------------
//      MAIN MAP INITIALISATION (big useEffect)
//   ---------------------------------------------------------- */
//   useEffect(() => {
//     const loadMap = async () => {
//       if (!mapRef.current) return;

//       const { OlaMaps } = await import('olamaps-web-sdk');
//       const apiKey = process.env.REACT_APP_OLA_API_KEY;
//       const olaMaps = new OlaMaps({ apiKey });

//       const hasPickup = pickLng != null && pickLat != null;
//       const defaultCenter = hasPickup ? [pickLng, pickLat] : [77.0679, 28.4354];
//       const myMap = olaMaps.init({
//         style:
//           'https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json',
//         container: mapRef.current,
//         center: defaultCenter,
//         zoom: 15,
//       });
//       myMap.addControl(
//         olaMaps.addNavigationControls({ showCompass: true, showZoom: false })
//       );

//       /* ---------- helper: reverse‑geocode and set address ---------- */
//       const setters = { pickup: setPickupLocation, drop: setDropLocation };
//       const getAddressFromCoords = async (lat, lng, label) => {
//         try {
//           const res = await fetch(
//             `https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat},${lng}&api_key=${apiKey}`
//           );
//           const data = await res.json();
//           const address = data?.results?.[0]?.formatted_address || 'Unknown';
//           setters[label](address);
//           localStorage.setItem(`${label}Loc`, address);

//           // ★ FIX: mark that a “proper” selection happened
//           if (label === 'pickup') setIsPickupSelectedFromSuggestion(true);
//           if (label === 'drop') setIsDropSelectedFromSuggestion(true);
//         } catch (err) {
//           console.error('Reverse‑geocode failed', err);
//         }
//       };

//       /* ---------- ADD / UPDATE PICKUP MARKER ---------- */
//       if (pickLat && pickLng) {
//         const pickupMarker = olaMaps
//           .addMarker({ color: 'black', draggable: true, anchor: 'bottom', offset: [0, 6] })
//           .setLngLat([pickLng, pickLat])
//           .addTo(myMap);

//         pickupMarker.on('dragend', () => {
//           const { lat, lng } = pickupMarker.getLngLat();

//           setPickLat(lat);
//           setPickLng(lng);
//           setLatitude(lat);
//           setLongitude(lng);
//           localStorage.setItem('pickLatitude', lat);
//           localStorage.setItem('pickLongitude', lng);

//           /* ★ FIX: treat drag as a valid selection */
//           setIsPickupSelectedFromSuggestion(true);
//           getAddressFromCoords(lat, lng, 'pickup');
//         });

//         // Initial reverse‑geocode
//         getAddressFromCoords(pickLat, pickLng, 'pickup');
//       }

//       /* ---------- ADD / UPDATE DROP MARKER ---------- */
//       if (dropLat && dropLng) {
//         const dropMarker = olaMaps
//           .addMarker({ color: 'green', draggable: true, anchor: 'bottom', offset: [0, 6] })
//           .setLngLat([dropLng, dropLat])
//           .addTo(myMap);

//         dropMarker.on('dragend', () => {
//           const { lat, lng } = dropMarker.getLngLat();

//           setDropLat(lat);
//           setDropLng(lng);
//           setDropLatitude(lat);
//           setDropLongitude(lng);
//           localStorage.setItem('dropLatitude', lat);
//           localStorage.setItem('dropLongitude', lng);

//           /* ★ FIX: treat drag as a valid selection */
//           setIsDropSelectedFromSuggestion(true);
//           getAddressFromCoords(lat, lng, 'drop');
//         });

//         getAddressFromCoords(dropLat, dropLng, 'drop');
//       }
//     };

//     /* small delay is fine; keeps React 18 happy */
//     const t = setTimeout(loadMap, 100);
//     return () => clearTimeout(t);
//   }, [
//     pickLat,
//     pickLng,
//     dropLat,
//     dropLng,
//     setLatitude,
//     setLongitude,
//     setDropLatitude,
//     setDropLongitude,
//     setPickupLocation,
//     setDropLocation,
//     setIsPickupSelectedFromSuggestion, // ★ FIX: dependencies
//     setIsDropSelectedFromSuggestion,   // ★ FIX
//   ]);

//   /* ---------------------------------------------------------- */
//   return (
//     <div
//       id="map"
//       ref={mapRef}
//       style={{
//         backgroundImage: `url(${mapimage})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         width: '100vw',
//         height: inSideSelectOnMap ? '100vh' : '30vh',
//       }}
//     />
//   );
// };

// export default DummyMapFromOLA;
